import * as REACT from "react";
import { Navigate, useNavigate } from 'react-router-dom';

class PageHelper {

  static refreshPage = () => {
    window.location.href = window.location.href;
  }

  static urlClean = () => {
    let Urloriginal =  window.location.href.split('?');
    let baseUrl   =  Urloriginal[0];      
    return baseUrl // window.location.origin + window.location.pathname <-
  }

  static GotoHomePage = () => {
    
    const navigate = useNavigate();
    navigate('/');
  }
}
export default PageHelper;